import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { MerchantsPage } from './pages/MerchantsPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/comercios" element={<MerchantsPage data-id="element-5" />} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}